/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { useDispatch, useSelector } from 'react-redux';
import {
    selectPayrollData,
    addPayrollData
} from '../features/payroll/payrollSlice'
import GetInvoice from '../backendHandler/invoicesRoute'
import Deductions from './Deductions'
import Support from './Support'

var whyReactWhy = 'Full Standard Van Route'
var outsideReactAbbrev = 'DBS2'
var outsideSupportCount = 0
var outsideDeductionCount = 0

var outsideSupportArray = [
    'none',
    'Late Wave Payment',
    'Additional Support',
    'Seasonal Incentive',
    'DPMO Incentive',
    'Support',
    'Performance Bonus',
    'TOLL'
]
var outsideDeductionList = [
    'none',
    'HiVis',
    'Key Chain',
    'Fuel Card Charge',
    'Deduction'
]


const DashboardForm = (props) => {
    // using the new backend route
    const [ requestGate, setRequestGate ] = useState(false)
    const [ handleSchedule, setHandleSchedule ] = useState(null)
    const [ dateSelection, setDateSelection ] = useState(new Date())

    // useEffect( () => {
    //     setHandleSchedule(
    //         <>
    //             <GetInvoice 
    //                 allGate={false}
    //                 dateSelection={dateSelection}
    //             />
    //         </>
    //     )
    // }, [requestGate, dateSelection])


    const payrollData = useSelector(selectPayrollData)

    async function postDataPayroll(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
            });

        return response ? response.json() : console.log('no reponse')
    };

    const dispatch = useDispatch()

    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    var CryptoJS = require("crypto-js");
    const [ myForm, setMyForm ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('Bristol - DBS2')
    const [ selectedCityAbbrev, setSelectedCityAbbrev ] = useState('DBS2')
    const [ selectedRouteType, setSelectedRouteType ] = useState('Full Standard Van Route')
    const [ otherSelection, setOtherSelection] = useState(null)
    const [ makeSearchBarVisible, setMakeSearchBarVisible ] = useState('dashboard_form_divs_name_bar_none')
    const [ driverSearchArray, setDriverSearchArray ] = useState([])
    const [ nameState, setNameState ] = useState('')
    const [ waveTime, setWaveTime ] = useState('')
    const [ startMileage, setStartMileage ] = useState('')
    const [ vehicleType, setVehicleType ] = useState('')
    const [ parcelsNotDelivered, setParcelsNotDelivered ] = useState('')
    const [ logOutTime, setLogOutTime ] = useState('')
    const [ finishMileage, setFinishMileage ] = useState('')
    const [ routeNumber, setRouteNumber ] = useState('')
    const [ parcelsDelivered, setParcelsDelivered ] = useState('')
    const [ vehicleRegistaration, setVehicleRegistaration ] = useState('')
    const [ logInTime, setLogInTime ] = useState('')
    const [ support, setSupport ] = useState(0)
    const [ deductions, setDeductions ] = useState(0)
    const [ deductionType, setDeductionType ] = useState('none')
    const [ supportType, setSupportType ] = useState('none')
    const [ deductionArea, setDeductionArea ] = useState(null)
    const [ deductionComment, setDeductionComment ] = useState('')
    const [ supportArea, setSupportArea ] = useState(null)
    const [ supportComment, setSupportComment ] = useState('')
    const [ reRender, setReRender] = useState(0)
    const [ submitButtonText, setSubmitButtonText ] = useState(null)
    const [ deductionsList, setDeductionsList ] = useState([])
    const [ supportList, setSupportList ] = useState([])
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ textMaker, setTextMaker ] = useState('none')
    const [ supportMaker, setSupportMaker ] = useState('none')
    const [ submitGate, setSubmitGate ] = useState(false)
    const [ loadedSupportComment, setLoadedSupportComment ] = useState('')
    const [ loadedDeductionComment, setLoadedDeductionComment ] = useState('')
    const [ localDriver, setLocalDrivers ] = useState(null)

    // deductions and support
    const [ deductionArray, setDeductionArray ] = useState([])
    const [ supportRenderList, setSupportRenderList ] = useState([])
    const [ addSupport, setAddSupport ] = useState(false)
    const [ addDeduction, setAddDeduction ] = useState(false)
    const [ deductionsToSubmit, setDeductionsToSubmit ] = useState([])
    const [ supportToSubmit, setSupportToSubmit ] = useState([])
    const [ lockedScreen, setLockedScreen ] = useState(null)

    useEffect( () => {
        setLocalDrivers(props.drivers)
    }, [props])

    // list for routes
    const onSelectTwo = (e) => {
        setSelectedRouteType(e.value)
    }

    // reload force chagne data to normal
    useEffect( () => {
        setSupportComment('')
        setDeductionComment('')
        setTextMaker('none')
        setSupportMaker('none')
    }, [submitGate])

    useEffect( () => {
        whyReactWhy = selectedRouteType
    }, [selectedRouteType])

    // console logger
    useEffect( () => {
        outsideReactAbbrev = selectedCityAbbrev
    }, [selectedCityAbbrev])
    // dropdown menu selection function
    const onSelect = (e) => {
        setSelectedCityAbbrev(e.value)
    }

    // dropdown menu selection function
    const onSelectDeduction = (e) => {
        setDeductionType(e.value)
        setTextMaker(e.value)
    }

    // dropdown menu selection function
    const onSelectSupport = (e) => {
        setSupportType(e.value)
        setSupportMaker(e.value)
    }

    // function for getting rid of the submit
    const handleSubmitButtonText = () => {
        setSubmitButtonText(null)
    }

    // timing delay on getting rid of the message
    useEffect( () => {
        if (submitButtonText !== null) {
            setTimeout( () => {
                setSubmitButtonText(null)
            }, 3000)
        }
    }, [submitButtonText])

    // submit for state form
    const handleSubmitState = (e) => {
        e.preventDefault()
        let localDriverId = 0
        let localID = 0
        let driverID = ''
        if (props.drivers) {
            props.drivers.forEach( (ele, id) => {
                if (ele.name === nameState) {
                    localDriverId = ele.driver_id
                }
            })
            if (localDriverId > 0) {
                async function postDataLocal(url = '', data = {}) {
                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const response = await fetch(url, {
                        method: 'POST', 
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${originalText}`
                        },
                        body: JSON.stringify(data)
                        });
            
                    return response ? response.json() : console.log('no reponse')
                };
                postDataLocal(`https://backendpajamas.herokuapp.com/singledriverdates/`, {
                    date: props.otherSelection.date,
                    week: new Date(props.otherSelection.date).getWeek()
                }).then( response => {
                    response.data.forEach( ele => {
                        if (ele.driver_id === `https://backendpajamas.herokuapp.com/drivers/${localDriverId}/` && ele.date === props.otherSelection.date) {
                            driverID = ele.driver_id
                            localID = ele.date_id
                        }
                    })       
                     async function getData(url = '') {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'GET', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            }
                        });
                        return response ? response.json() : console.log('no reponse')
                    };
                    getData(`https://backendpajamas.herokuapp.com/schedule/${localID}/`).then( responseData => {
                        let localManagerArray = responseData.manager_movement

                        localManagerArray.push(`${props.userId}&${new Date()}&daily`)

                        async function postData(url = '', data = {}) {
                            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                            let originalText = bytes.toString(CryptoJS.enc.Utf8);
                            const response = await fetch(url, {
                                method: 'PUT', 
                                mode: 'cors',
                                cache: 'no-cache',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Token ${originalText}`
                                },
                                body: JSON.stringify(data)
                                });
                
                            return response ? response.json() : console.log('no reponse')
                        };
                        async function postDataPost(url = '', data = {}) {
                            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                            let originalText = bytes.toString(CryptoJS.enc.Utf8);
                            const response = await fetch(url, {
                                method: 'POST', 
                                mode: 'cors',
                                cache: 'no-cache',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Token ${originalText}`
                                },
                                body: JSON.stringify(data)
                                });
                
                            return response ? response.json() : console.log('no reponse')
                        };
                        let logInLocal = logInTime.slice(0, 5)
                        let logOutLocal = logOutTime.slice(0, 5)
                
                        let myObjectToPut = () => {
                            let myObj = {
                                name: nameState,
                                start_mileage: startMileage,
                                route: whyReactWhy ? whyReactWhy : 'Full Standard Van Route',
                                logOut_time: logOutLocal,
                                logIn_time: logInLocal,
                                finish_mileage: finishMileage,
                                LateWavePayment: waveTime,
                                location: outsideReactAbbrev,
                                parcel: parcelsDelivered,
                                parcelNotDelivered: parcelsNotDelivered,
                                driver_id: driverID,
                                routeNumber: routeNumber,
                                manager_id: props.userId,
                                manager_movement: localManagerArray
                            }
                
                            return (
                                myObj
                            )
                        }
            
                        const makeValues = (deductionName, deductionAmount) => {
                            if (deductionName === 'HiVis' || deductionName === 'Key Chain') {
                                return 5
                            } else {
                                return deductionAmount > 0 ? deductionAmount : 0
                            }
                        }
                
                        let myDeductionsObj = () => {
                            let deductionsArrayLocal = []
                            deductionsToSubmit.forEach( deduction => {
                                let myObj = {}
                                if (deduction.type !== 'none' && deduction.type !== 'selectMe') {
                                    myObj = {
                                        date_id: `https://backendpajamas.herokuapp.com/schedule/${localID}/`,
                                        name: deduction.type,
                                        amount: makeValues(deduction.type, deduction.amount),
                                        comment: deduction.comment ? deduction.comment : deduction.type,
                                        date: props.otherSelection.date,
                                        week_number: new Date(props.otherSelection.date).getWeek()
                                    }
                                } 
                                if (myObj.type !== 'selectMe' && myObj.type !== 'none' && myObj.amount !== 0) {
                                    if (myObj.name !== null) {
                                        deductionsArrayLocal.push(myObj)
                                    }
                                }
                            })
                            return deductionsArrayLocal
                        }
                
                        let mySupportsObj = () => {
                            let supportArrayLocal = []
                            supportToSubmit.forEach( support => {
                                let myObj = {}
                                if (support.type !== 'none' && support.type !== 'selectMe') {
                                    myObj = {
                                        date_id: `https://backendpajamas.herokuapp.com/schedule/${localID}/`,
                                        name: support.type,
                                        amount: support.amount > 0 ? support.amount : 0,
                                        comment: support.comment ? support.comment : support.type,
                                        date: props.otherSelection.date,
                                        week_number: new Date(props.otherSelection.date).getWeek()
                                    }
                                }
                                if (support.type !== 'selectMe' && support.type !== 'none' && support.amount !== 0) {
                                    if (myObj.name !== null) {
                                        supportArrayLocal.push(myObj)
                                    }
                                }
                            })
                            return supportArrayLocal
                        }
                        if (localID.length > 0) {
                            let deductionsArray = myDeductionsObj()
                            let supportArray = mySupportsObj()
                            deductionsArray.forEach( deduction => {
                                if (deduction.name) {
                                    postDataPost(`https://backendpajamas.herokuapp.com/deductions/`, deduction)
                                }
                            })
                            supportArray.forEach( support => {
                                if (support.name) {
                                    postDataPost(`https://backendpajamas.herokuapp.com/support/`, support)
                                }
                            })
                            postData(`https://backendpajamas.herokuapp.com/schedule/${localID}/`, myObjectToPut()).then( response => {
                                submitGate === false ? setSubmitGate(true) : setSubmitGate(false)
                                props.updateParentFunction()
                            })
                            setSubmitButtonText(
                                <div id='boxForClicking'>
                                    <h3>You have succesfully submitted the data!</h3>
                                    <div id='dashboardFormSubmitButton' onClick={handleSubmitButtonText}>Exit</div>
                                </div>
                            )
                        }
                    })
                })
            }
        }
    }

    // dropdown menu options
    const options = [
        'DBS2',
        'DSN1',
        'DEX2',
        'DXP1',
        'DCF1'
    ]
    
    // 'Transportation Route',
    // 'MFN Route',

    // dropdown for route menu
    const optionsTwo = [
        'Full Standard Van Route',
        'Full Large Van Route',
        'Rescue Payment',
        'Classroom Training',
        'Jumper',
        'Half Standard Van Route',
        'Ride Along',
        'Manager',
    ]

    // make the div under the name search bar
    const makeSearchUnderBar = (theValue, theLength) => {
        if (theValue !== '' && theLength <= 3) {
            setMakeSearchBarVisible('dashboard_form_divs_name_bar')
        } else {
            setMakeSearchBarVisible('dashboard_form_divs_name_bar_none')
        }
    }
    
    // map props to state
    useEffect( () => {
        outsideSupportArray = [
            'none',
            'Late Wave Payment',
            'Additional Support',
            'Abortive Payment',
            'Seasonal Incentive',
            'DPMO Incentive',
            'Support',
            'Performance Bonus',
            'TOLL',
            'R2',
            'R4',
            'R6'
        ]
        outsideDeductionList = [
            'none',
            'HiVis',
            'Key Chain',
            'Fuel Card Charge',
            'Deduction'
        ]
        setDeductionArray([])
        setSupportRenderList([])
        setSupportToSubmit([])
        setDeductionsToSubmit([])
        setDeductionType('none')
        setSupportType('none')
        if (props.otherSelection) {
            if (props.otherSelection.supportList) {
                props.otherSelection.supportList.forEach( supportItem => {
                    if (outsideSupportArray.includes(supportItem.name)) {
                        let localArray = []
                        outsideSupportArray.forEach( item => {
                            if (item !== supportItem.name) {
                                localArray.push(item)
                            }
                        })
                        outsideSupportArray = localArray
                    }
                })
            }
            if (props.otherSelection.deductionList) {
                props.otherSelection.deductionList.forEach( supportItem => {
                    if (outsideDeductionList.includes(supportItem.name)) {
                        let localArray = []
                        outsideDeductionList.forEach( item => {
                            if (item !== supportItem.name) {
                                localArray.push(item)
                            }
                        })
                        outsideDeductionList = localArray
                    }
                })
            }
            setSelectedCityAbbrev(props.otherSelection.location)
            let deductionsValue = props.otherSelection.deductionSum.replace(/GB£/, '')
            let supportValue = props.otherSelection.supportSum.replace(/GB£/, '')
            if (props.otherSelection.route !== "0") {
                setSelectedRouteType(props.otherSelection.route)
            } else {
                setSelectedRouteType('Full Standard Van Route')
            }
            setOtherSelection(props.otherSelection)
            setNameState(props.driverName)
            setWaveTime(props.otherSelection.LateWavePayment)
            setStartMileage('0')
            setVehicleType('Not Owned')
            setParcelsNotDelivered(props.otherSelection.parcelNotDelivered)
            setLogOutTime(props.otherSelection.logOut_time)
            setFinishMileage(props.otherSelection.finish_mileage)
            setRouteNumber(props.otherSelection.route)
            setParcelsDelivered(props.otherSelection.parcel)
            setVehicleRegistaration('0')
            setLogInTime(props.otherSelection.logIn_time)
            setRouteNumber(props.otherSelection.routeNumber)
            setSupport(0)
            setDeductions(0)
            setDeductionsList(makeDeductionsList(props.otherSelection))
            setSupportList(makeSupportList(props.otherSelection))
        } else {
            setOtherSelection('')
            setNameState('')
            setWaveTime('')
            setStartMileage('0')
            setVehicleType('Not Owned')
            setParcelsNotDelivered('')
            setLogOutTime('')
            setFinishMileage('')
            setRouteNumber('')
            setParcelsDelivered('')
            setVehicleRegistaration('0')
            setLogInTime('')
            setRouteNumber('')
            setSupport('')
            setDeductions('')
            setDeductionsList(makeDeductionsList(null))
            setSupportList(makeSupportList(null))
        }

    }, [props.otherSelection, props.locked])

    // handle the input changes
    const handleChangeInputs = (e) => {
        let myVar = reRender
        let newVar = myVar + 1
        let x = 0
        e.target.name === 'Name' ? setNameState(e.target.value) : x = x + 1
        e.target.name === 'waveTime' ? setWaveTime(e.target.value) : x = x + 1
        e.target.name === 'LogOutTime' ? setLogOutTime(e.target.value) : x = x + 1
        e.target.name === 'StartMileage' ? setStartMileage(e.target.value) : x = x + 1
        e.target.name === 'FinishMileage' ? setFinishMileage(e.target.value) : x = x + 1
        e.target.name === 'VehicleType' ? setVehicleType(e.target.value) : x = x + 1
        e.target.name === 'Route' ? setRouteNumber(e.target.value) : x = x + 1
        e.target.name === 'ParcelsDelivered' ? setParcelsDelivered(e.target.value) : x = x + 1
        e.target.name === 'ParcelsNotDelivered' ? setParcelsNotDelivered(e.target.value) : x = x + 1
        e.target.name === 'LogInTime' ? setLogInTime(e.target.value) : x = x + 1
        e.target.name === 'deductions' ? setDeductions(e.target.value) : x = x + 1
        e.target.name === 'support' ? setSupport(e.target.value) : x = x + 1
        setReRender(newVar)
    }

    let myDeductionList = [
        'none',
        'HiVis',
        'Key Chain',
        'Fuel Card Charge',
        'Deduction'
    ]

    let mySupportList = [
        'Late Wave Payment',
        'Additional Support',
        'Manual'
    ]

    let mySuperSupportList = [
        'none',
        'Late Wave Payment',
        'Additional Support',
        'Seasonal Incentive',
        'DPMO Incentive',
        'Support',
        'Performance Bonus',
        'TOLL'
    ]

    const handleDeductionComment = (e) => {
        setDeductionComment(e.target.value)
    }
    
    useEffect( () => {
        if (textMaker !== 'none') {
            setDeductionArea(
                <textarea onChange={handleDeductionComment} rows="4" cols="50" id='deduction_textarea'>
                    {deductionComment}
                </textarea>
            )
        } else {
            setDeductionArea(null)
        }
    }, [textMaker, deductionComment])
    
    const handleSupportComment = (e) => {
        setSupportComment(e.target.value)
    }

    useEffect( () => {
        if (supportMaker !== 'none') {
            setSupportArea(
                <textarea onChange={handleSupportComment} rows="4" cols="50" id='deduction_textarea'>
                    {supportComment}
                </textarea>
            )
        } else {
            setSupportArea(null)
        }
    }, [supportMaker, supportComment])

    const handleDeleteErrorGlobal = () => {
        setErrorMessage(null)
    }

    // send request to the backend for delete and rerender
    const handleDeleteDate = (e, theItem) => {
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

        };

        deleteData(`https://backendpajamas.herokuapp.com/support/${theItem.support_id}/`).then( response => {
            handleDeleteErrorGlobal()
            props.updateParentFunction()
        })
    }

    // send request to the backend for delete and rerender
    const handleDeleteDateDeduction = (e, theItem) => {
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

        };

        deleteData(`https://backendpajamas.herokuapp.com/deductions/${theItem.deduction_id}/`).then( response => {
            handleDeleteErrorGlobal()
            props.updateParentFunction()
        })
    }

    // handle deleting support or deduction
    const handleDelete = (e, theItem) => {
        setErrorMessage(
            <div className='makeMeBig_two'>
                <div className='deletionObjectionTwo'>
                    <h3 id='errorMessage'>Would you like to delete {theItem.name}? </h3>
                    <div>
                        <button className='deleteButton' onClick={(e, aDate) => handleDeleteDate(e, theItem)}>Delete</button>
                        <button className='returnButton' onClick={handleDeleteErrorGlobal}>Return</button>
                    </div>
                </div>
            </div>
        )
    }

    // handle deleting support or deduction
    const handleDeleteDeduction = (e, theItem) => {
        setErrorMessage(
            <div className='makeMeBig_two'>
                <div className='deletionObjectionTwo'>
                    <h3 id='errorMessage'>Would you like to delete {theItem.name}? </h3>
                    <div>
                        <button className='deleteButton' onClick={(e, aDate) => handleDeleteDateDeduction(e, theItem)}>Delete</button>
                        <button className='returnButton' onClick={handleDeleteErrorGlobal}>Return</button>
                    </div>
                </div>
            </div>
        )
    }

    const makeDeductionsList = (theDate) => {
        let localArray = []
        if (props.locked) {
            if (theDate) {
                theDate.deductionList.forEach( (deduction, deductionID) => {
                    localArray.push(
                        <div className='deductionItem' key={deductionID}>
                            Name: {deduction.name} <br />
                            Amount: {deduction.amount} <br />
                            Comment: {deduction.comment}
                        </div>
                    )
                })
            }
        } else {
            if (theDate) {
                theDate.deductionList.forEach( (deduction, deductionID) => {
                    localArray.push(
                        <div className='deductionItem' key={deductionID} onClick={(e, theDeduction) => handleDeleteDeduction(e, deduction)}>
                            Name: {deduction.name} <br />
                            Amount: {deduction.amount} <br />
                            Comment: {deduction.comment}
                        </div>
                    )
                })
            }
        }
        return localArray
    }

    const makeSupportList = (theDate) => {
        let localArray = []
        if (props.locked) {
            if (theDate) {
                theDate.supportList.forEach( (support, supportID) => {
                    localArray.push(
                        <div className='supportItem' key={supportID} >
                            Name: {support.name} <br />
                            Amount: {support.amount} <br />
                            Comment: {support.comment}
                        </div>
                    )
                })
            }
        } else {
            if (theDate) {
                theDate.supportList.forEach( (support, supportID) => {
                    localArray.push(
                        <div className='supportItem' key={supportID} onClick={(e, theDeduction) => handleDelete(e, support)}>
                            Name: {support.name} <br />
                            Amount: {support.amount} <br />
                            Comment: {support.comment}
                        </div>
                    )
                })
            }
        }
        return localArray
    }

    // map the deduction values
    const deductionValueMap = (dedType, dedValue) => {
        if (dedType === 'HiVis' || dedType === 'Key Chain') {
            return 5
        } else if (dedValue === 0) {
            return ''
        } else {
            return deductions
        }
    }

    // functions for adding deductions or support
    const handleAddDeduction = () => {
        addDeduction ? setAddDeduction(false) : setAddDeduction(true)
    }

    const handleAddSupport = () => {
        addSupport ? setAddSupport(false) : setAddSupport(true)
    }

    // function for support entry
    const handleSupportEntry = (supportType, supportAmount, localSupportComment, count) => {
        supportToSubmit[count] = {
            'type': supportType,
            'amount': supportAmount,
            'comment': localSupportComment
        }
    }

    // function for support entry
    const handleDeductionEntry = (deductionType, deductionAmount, deductionComment, count) => {
        deductionsToSubmit[count] = {
            'type': deductionType,
            'amount': deductionAmount,
            'comment': deductionComment
        }
    }

    // function for tracking supports
    const supportTracker = (value) => {
        let localOutside = []
        if (outsideSupportArray.includes(value)) {
            outsideSupportArray.forEach( ele => {
                if (ele !== value) {
                    localOutside.push(ele)
                }
            })
            outsideSupportArray = localOutside
        }
    }

    // function for tracking deductions
    const deductionTracker = (value) => {
        let localOutside = []
        if (outsideDeductionList.includes(value)) {
            outsideDeductionList.forEach( ele => {
                if (ele !== value) {
                    localOutside.push(ele)
                }
            })
            outsideDeductionList = localOutside
        }
    }

    // onClick add a support
    useEffect( () => {
        let localList = [...supportRenderList, <Support 
            index={outsideSupportCount} 
            dataEntered={handleSupportEntry}
            supportTracking={supportTracker}
            allowedList={outsideSupportArray}
            />
        ]
        setSupportRenderList(localList)
        outsideSupportCount++
    }, [addSupport])

    // onClick add a deduction
    useEffect( () => {
        let localList = [...deductionArray, <Deductions 
            index={outsideDeductionCount} 
            dataEntered={handleDeductionEntry}
            deductionTrackerLocal={deductionTracker}
            deductionListLocal={outsideDeductionList}
            />
        ]
        setDeductionArray(localList)
        outsideDeductionCount++
    }, [addDeduction])

    useEffect( () => {
        if (props.locked) {
            setLockedScreen('overallHider')
        } else {
            setLockedScreen('')
        }
    }, [props.locked])

    useEffect( () => {
        setMyForm(
            <form onSubmit={handleSubmitState}  autoComplete='off'>
                <div className='dashboard_form'>
                    <div className='dashboard_form_divs_name'>
                        <div>
                            <label className='dashboard_labels'>Name</label>
                        </div>
                            <input className='input_dashboard_page' type="text" name='Name' value={nameState} onChange={handleChangeInputs}/>
                    </div>
                    <div className='dashboard_form_divs'>    
                        <div>
                        </div><label className='dashboard_labels'>Location </label>
                        <Dropdown 
                            options={options} 
                            onChange={onSelect} 
                            value={selectedCityAbbrev} 
                            placeholder="Select an option" 
                            className='drop_down_bar_dashboard'
                            id='drop_down_style'
                        />
                    </div>
                    <div className='dashboard_form_divs'>    
                        <div>
                            <label className='dashboard_labels'>Route No. </label>
                        </div>
                            <input className='input_dashboard_page' type="text" name='Route' value={routeNumber === '0' ? '' : routeNumber} onChange={handleChangeInputs}/>
                    </div>
                    <div className='dashboard_form_divs'>
                        <div>
                            <label className='dashboard_labels'>Route Type</label>
                        </div>
                        <Dropdown 
                            options={optionsTwo} 
                            onChange={onSelectTwo} 
                            value={selectedRouteType ? selectedRouteType : optionsTwo[0]} 
                            placeholder="Select an option" 
                            className='drop_down_bar_dashboard'
                            id='drop_down_style'
                        />
                    </div>
                    <div className='dashboard_form_divs'>
                        <div>
                            <label className='dashboard_labels'>Log In Time </label>
                        </div>
                            <input className='input_dashboard_page' type="time" name='LogInTime' value={logInTime} onChange={handleChangeInputs} required/>
                    </div>
                    <div className='dashboard_form_divs'>
                        <div>
                            <label className='dashboard_labels'>Log Out Time </label>
                        </div>
                            <input className='input_dashboard_page' type="time" name='LogOutTime' value={logOutTime} onChange={handleChangeInputs} required/>
                    </div>
                    {supportRenderList}
                    {deductionArray}
                    <div className='dashboard_form_divs_list'>
                        <div>
                            <label className='dashboard_labels'>Support List </label>
                        </div>
                        <div className='makeColumn'>
                            {supportList}
                        </div>
                    </div>
                    <div className='dashboard_form_divs_list'>
                        <div>
                            <label className='dashboard_labels'>Deductions List </label>
                        </div>
                        <div className='makeColumn'>
                            {deductionsList}
                        </div>
                    </div>
                    {/* <div className='dashboard_form_divs_texty'>  
                            <div>
                                <label className='dashboard_labels'>Support </label>        
                            </div>
                        <div className='solve_this'>
                            <div>
                                <Dropdown 
                                    options={mySuperSupportList} 
                                    onChange={onSelectSupport} 
                                    value={supportType} 
                                    placeholder="Select an option" 
                                    className='drop_down_bar_dashboard'
                                    id='drop_down_style'
                                />
                                <input className='input_dashboard_page' type="text" name='support' value={support === 0 ? '' : support} onChange={handleChangeInputs}/>
                                {supportArea}
                            </div>
                            {supportList}
                        </div>  
                    </div>
                    <div className='dashboard_form_divs_texty'>    
                        <div>
                            <label className='dashboard_labels'>Deduction </label>        
                        </div>
                        <div className='solve_this'>
                            <div>
                                <Dropdown 
                                    options={myDeductionList} 
                                    onChange={onSelectDeduction} 
                                    value={deductionType} 
                                    placeholder="Select an option" 
                                    className='drop_down_bar_dashboard'
                                    id='drop_down_style'
                                />
                                <input className='input_dashboard_page' type="text" name='deductions' value={deductionValueMap(deductionType, deductions)} onChange={handleChangeInputs}/>
                                <div className='deductionsListOverall'>
                                    {deductionArea}
                                </div>
                            </div>
                        {deductionsList}
                        </div>
                    </div> */}
                    {/* <div className='dashboard_form_divs'>
                        <div>
                            <label className='dashboard_labels'>Start Mileage </label>
                        </div>
                            <input className='input_dashboard_page' type="text" name='StartMileage' value={startMileage} onChange={handleChangeInputs}/>
                    </div> */}
                    <div className='dashboard_form_divs'>
                        <div>
                            <label className='dashboard_labels'>Finish Mileage </label>
                        </div>
                            <input className='input_dashboard_page' type="text" name='FinishMileage' value={finishMileage === 0 ? '' : finishMileage} onChange={handleChangeInputs}/>
                    </div>        
                </div>
                {submitButtonText}
                <div className={lockedScreen}>
                    <div className='addDeductionSupport'>
                        <div className="button_daily_service" onClick={handleAddSupport}>
                            <h3 className='remove_h3_padding'>
                                Support
                            </h3>
                        </div>
                        <div className="button_daily_service" onClick={handleAddDeduction}>
                            <h3 className='remove_h3_padding'>
                                Deduction
                            </h3>
                        </div>
                    </div>
                    <div className="button_daily_service" onClick={handleSubmitState}>
                        <h3 className='remove_h3_padding'>submit</h3>  
                    </div>  
                </div>
                <br />
            </form>
        )
    }, [otherSelection, deductionArea, supportArea, reRender, submitButtonText, supportRenderList, deductionArray, lockedScreen])
    
    return (
       <>
            {handleSchedule}
            {errorMessage}
            {myForm}
       </>
    )
}

export default DashboardForm